import { Serializable } from 'types/interfaces';

export interface Pasos {
  id: string;
  solicitud_de_registro: string;
  paso: string;
  fecha_start: string;
  fecha_finish: string;
  acabado: boolean;
  mensaje_recordatorio_enviado: boolean;
  fecha_envio: string;
  numero_de_mesajes_enviados: number;
  mensajes_de_error: string[];
}
export interface SolicitudPendienteAPI {
  id: string;
  nombre: string;
  apellidos: string;
  nif: string;
  comunidad: number;

  nombre_comunidad: string;
  aceptacion_rgpd: boolean;
  email: string;
  telefono: string;
  tipo_propiedad: string;
  tipo_solicitante: string;
  codigo_postal_fiscal: string;
  idioma: string;
  realiza_una_activitad_economica: boolean;
  cups: string;
  razon_social_empresa: string;
  nif_empresa: string;
  domicilio_fiscal: string;
  dni: Documento[];
  factura: Documento[];
  permiso_datadis: boolean;
  permiso_procesado_mediante_datadis: boolean;
  aceptacion_ia: boolean;
  domicilio: string;
  poblacion: string;
  provincia: string;
  codigo_postal: string;
  direccion_completa: string;
  tipo_consumo: string;
  tarifa_PVPC: boolean;
  precio_compensacion: number;
  potencia_contratada_p1: number;
  potencia_contratada_p2: number;
  potencia_contratada_p3: number;
  potencia_contratada_p4: number;
  potencia_contratada_p5: number;
  potencia_contratada_p6: number;
  termino_energia_p1: number;
  termino_energia_p2: number;
  termino_energia_p3: number;
  termino_energia_p4: number;
  termino_energia_p5: number;
  termino_energia_p6: number;
  tarifa: string;
  codigo_comercializadora: string;
  margen_mensual: number;
  margen_kwh: number;
  geo_latitud: number;
  geo_longitud: number;
  encuesta_obligatoria: EncuestaObligatoria;
  datadis_signaturit_document_firmado?: boolean;
  contrato_adgesion_signaturit_document_firmado?: boolean;
  acuerdo_reparto_signaturit_document_firmado?: boolean;
  pasos?: Pasos[];
}

export interface Documento {
  id: number;
  tipo: string;
  documento: string;
}
export interface PreguntaOpcional {
  pregunta: string;
  respuesta: string;
}

export interface EncuestaObligatoria {
  tiene_vehiculo_electrico: boolean;
  tiene_calefaccion_electrica: boolean;
  tiene_calentador_de_agua_electrico: boolean;
  otra_informacion_util: string;
  codigo_cnae: string;
  preguntas_opcionales?: PreguntaOpcional[];
}

export class SolicitudPendiente implements Serializable<SolicitudPendiente> {
  id: string;

  nombre: string;

  apellidos: string;

  nif: string;

  comunidad: number;

  nombre_comunidad: string;

  aceptacion_rgpd: boolean;

  email: string;

  telefono: string;

  tipo_propiedad: string;

  tipo_solicitante: string;

  codigo_postal_fiscal: string;

  idioma: string;

  realiza_una_activitad_economica: boolean;

  cups: string;

  razon_social_empresa: string;

  nif_empresa: string;

  domicilio_fiscal: string;

  dni: Documento[];

  factura: Documento[];

  permiso_datadis: boolean;

  permiso_procesado_mediante_datadis: boolean;

  aceptacion_ia: boolean;

  domicilio: string;

  poblacion: string;

  provincia: string;

  codigo_postal: string;

  direccion_completa: string;

  tipo_consumo: string;

  tarifa_PVPC: boolean;

  precio_compensacion: number;

  potencia_contratada_p1: number;

  potencia_contratada_p2: number;

  potencia_contratada_p3: number;

  potencia_contratada_p4: number;

  potencia_contratada_p5: number;

  potencia_contratada_p6: number;

  termino_energia_p1: number;

  termino_energia_p2: number;

  termino_energia_p3: number;

  termino_energia_p4: number;

  termino_energia_p5: number;

  termino_energia_p6: number;

  tarifa: string;

  codigo_comercializadora: string;

  margen_mensual: number;

  margen_kwh: number;

  geo_latitud: number;

  geo_longitud: number;

  encuesta_obligatoria: EncuestaObligatoria;

  datadis_signaturit_document_firmado?: boolean;

  contrato_adgesion_signaturit_document_firmado?: boolean;

  acuerdo_reparto_signaturit_document_firmado?: boolean;

  pasos?: Pasos[];

  deserialize(input: SolicitudPendienteAPI): SolicitudPendiente {
    Object.assign(this, input);
    return this;
  }

  serialize(): SolicitudPendienteAPI {
    return { ...this };
  }

  deserializeArray(input: SolicitudPendienteAPI[]): SolicitudPendiente[] {
    return input.map((i) => new SolicitudPendiente().deserialize(i));
  }
}
